<template>
  <div class="paddingTopPage centre">
    <ToolbarTop url="/verzeichnis" backLabel="Verzeichnis"></ToolbarTop>
    <div v-if="!this.$store.state.fratiOk">
      <img src="@/assets/img/wheel.gif">
    </div>
    <div class="mb20" v-if="this.$store.state.fratiOk">
      <div class="title">Nekrolog</div>

      <div class="input-container">
        <input
          v-model="searchInput"
          type="text"
          placeholder=" Suchen..."
          class="filter-input">
      </div>

      <!-- Ogni frate defunto -->
      <div v-for="(item, index) in filteredFrati" :key="index">
        <div class="card flex align-items-center line-height-0">
          <router-link :to="{ name: 'Bruder',  params: { bruder: nameAndSurname(item.name, item.vorname) } }">
            <div><img :src="foto(item.foto)" width="75" height="75" /></div>
          </router-link>
          <div class="cardTextBlock flex justify-content-left flex-direction-column">

            <router-link class="font20 jauneclair bold" :to="{ name: 'Bruder',  params: { bruder: nameAndSurname(item.name, item.vorname) } }">
              <div>{{ afficheVornameName(item.vorname, item.name) }}</div>
            </router-link>

        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolbarTop from './ToolbarTop.vue';

export default {
  name: 'NekrologPage',
  components: { ToolbarTop },
  data() {
    return {
      searchInput: "",
      bruderStatus: "D", // D = Defunto
    }
  },
  computed: {
    filteredFrati() {
      const search = this.searchInput.toLowerCase();
      return this.$store.state.frati
        .filter( (item) => item.status == this.bruderStatus )
        .filter( (item) => (item.vorname.trim() + " " + item.name.trim()).toLowerCase().includes(search) )
        .sort( (a, b) => {
          if ( a.vorname < b.vorname ) { return -1; }
          if ( a.vorname > b.vorname ) { return 1; }
          return 0;
        });
    },
  },
  beforeCreate() {
    // verify that the user is logged
    if ( localStorage.getItem("nameField") == null ) {
      this.$router.push({ path: '/', query: { callback: 'nekrolog' } })
    }
  },
  created() {
    // Load Frati
    if ( !this.$store.state.fratiOk ) {
      this.$store.dispatch("getFrati");
    }
  },
  methods: {
    afficheVornameName(vorname, name) {
      return vorname + " " + name.toUpperCase();
    },
    nameAndSurname(nom, prenom) {
      return nom.trim() + "-" + prenom.trim();
    },
    foto(fratefoto) {
      return this.$store.state.rootUrl + this.$store.state.imgUrl + fratefoto;
    },
    emailAdr(email) {
      return "mailto:" + email;
    },
    numTel(tel) {
      return "tel:" + tel;
    }
  }
}
</script>
